import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable, of } from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromStore from './store';
import {map, switchMap, take, catchError, filter} from 'rxjs/operators';
import {FirmWareService} from './services/firm-ware.service';
import {UtilsService, TOKEN} from './services/utils.service';
import {UsersState} from './store/reducers/user.reducers';
import {urlPath} from './shareModel';

@Injectable({
  providedIn: 'root'
})
export class AuthFirmwareGuard implements  CanActivate {
  IsFirmwareAdmin: boolean;
  constructor(
    private store: Store<fromStore.State>,
    private router: Router,
    private firmwareService: FirmWareService,
    private utils: UtilsService
  ) {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url: string = state.url;
    return this.packageSettingActivate(url);
  }
  canLoad(route: Route, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const url: string = state.url;
    return this.packageSettingActivate(url);
  }

  packageSettingActivate(url: string): Observable<boolean | UrlTree> {
    return this.store.select(fromStore.getCurrentUser).pipe(
      filter((user) => !user.isLoading && user.isLoaded),
      take(1),
      switchMap((user) => {
        const email = this.resolveEmailForFirmwareCheck(user);
        if (!email) {
          return of(this.firmwareDeniedUrlTree());
        }
        return this.firmwareService.CheckFirmwareAdmin(email).pipe(
          map((isAdmin) => {
            this.IsFirmwareAdmin = !!isAdmin;
            if (!isAdmin) {
              return this.firmwareDeniedUrlTree();
            }
            return true;
          }),
          catchError(() => of(this.firmwareDeniedUrlTree()))
        );
      })
    );
  }

  private firmwareDeniedUrlTree(): UrlTree {
    return this.router.parseUrl('/' + urlPath['Dashboard']);
  }

  private resolveEmailForFirmwareCheck(user: UsersState): string {
    const fromStoreEmail = (user && user.currentUser ? String(user.currentUser) : '').trim();
    if (fromStoreEmail) {
      return fromStoreEmail;
    }
    if (!user || !user.isLogin) {
      return '';
    }
    try {
      const jwtStr = this.utils.getToken(TOKEN);
      if (!jwtStr) {
        return '';
      }
      const parsed = JSON.parse(jwtStr);
      return (parsed && parsed.username ? String(parsed.username) : '').trim();
    } catch {
      return '';
    }
  }
}
